import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Grid,
  Grid2,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
// import { Link } from 'react-router-dom';
import upLine from "../../assets/images/upload-line.svg";
import downLine from "../../assets/images/download-line.svg";
import e1 from "../../assets/images/events_1.png";
import e2 from "../../assets/images/events_2.png";
import closeBtn from "../../assets/images/close.svg";
import qrimg from "../../assets/images/qr.png";
import copyClipboard from "../../assets/images/copy-clipboard.svg";

import Header from "../Header";
import Footer from "../Footer";
import { Link } from "react-router-dom";


const nftListData = [
  {
    title: "Raas Ratri : A Night of Dance and Devotion",
    id: "0.0.872340",
    symbol: "DPGP",
    image: e2,
    link: "/my-wallet/token-details",
  },
  {
    title: "Rhythm of the Dandiya",
    id: "0.0.8150915",
    symbol: "NFThonk",
    image: e1,
    link: "/my-wallet/token-details",
  },
  // { title: 'VirtualVentures', id: '0.0.8150370', symbol: 'VRTVNT', image: nftimage1, link: '/my-wallet/token-details' },
  // { title: 'MetaMasters', id: '0.0.8150360', symbol: 'MTMSTR', image: nftimage1, link: '/my-wallet/token-details' },
];

const historyData = [
  {
    title: "Raas Ratri : A Night of Dance and Devotion",
    time: "30 Sep 2025, 15:30 PM, ₹ 1500.00",
    image: e2,
    symbol: "Bought",
    type: "danger",
  },
  {
    title: "Rhythm of the Dandiya",
    time: "30 Oct 2025, 11:45 PM, ₹ 900.00",
    image: e2,
    symbol: "Listed",
    type: "success",
  },
  {
    title: "Rhythm of the Dandiya",
    time: "30 Oct 2025, 20:48 PM, ₹ 2500.00",
    image: e1,
    symbol: "Sold",
    type: "danger",
  },
];

const MyWallet = () => {
  const [selectedTicket, setSelectedTicket] = useState("myTicket");
  const [openModal, setOpenModal] = useState(false);
  const [openNextModal, setOpenNextModal] = useState(false);
  const [openReceivedModal, setOpenReceivedModal] = useState(false);
  const [openCopyModal, setOpenCopyModal] = useState(false); // New state for "Copy Address" modal

  const handleTicketClick = (ticket) => setSelectedTicket(ticket);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const handleOpenNextModal = () => {
    setOpenModal(false);
    setOpenNextModal(true);
  };
  const handleCloseNextModal = () => setOpenNextModal(false);
  const handleOpenReceivedModal = () => setOpenReceivedModal(true);
  const handleCloseReceivedModal = () => setOpenReceivedModal(false);
  const handleOpenCopyModal = () => setOpenCopyModal(true); // Open "Copy Address" modal
  const handleCloseCopyModal = () => setOpenCopyModal(false); // Close "Copy Address" modal
  return (
    <Box sx={{ flexGrow: 1 }}>
      <div className="center-App" container direction="column">
        <Header name="My Wallet" />
        <Box
          sx={{
            padding: "30px 30px",
            float: "left",
            width: "100%",
            height: "calc(100vh - 160px)",
            overflow: "auto",
          }}
        >
          <div container spacing={2}>
            {/* <Card sx={{ borderRadius: '10px', padding: "15px", boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}> */}

            <div
              className="position-relative radius-img-box"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box className="wallet-box">
                <Typography variant="h5" className="account-title ">
                  KS
                </Typography>
              </Box>
              <Typography
                variant="h5"
                component="div"
                sx={{
                  float: "left",
                  width: "calc(100% - 80px)",
                  color: "#6638A2",
                  marginTop: "5px",
                  marginBottom: "10px",
                  lineHeight: "27px",
                  fontWeight: "500",
                  paddingLeft: "15px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                Kaushal Sadhu
                <Typography
                  variant="h6"
                  component="div"
                  sx={{
                    float: "left",
                    color: "#341439",
                    marginTop: "5px",
                    fontSize: "18px",
                    marginBottom: "10px",
                    lineHeight: "27px",
                    fontWeight: "500",
                  }}
                >
                  Account ID : 0.0.5416445
                </Typography>
              </Typography>
            </div>

            {/* </Card> */}
            {/* <Box className="wallet-box">
                            <Typography className="account-title">Account Balance</Typography>
                            <Typography className="main-balance">80.258 HBAR</Typography>
                            <Typography className="account-id">Account ID : 0.0.5416445</Typography>
                            <div className="list-box">
                                <ul>
                                    <li onClick={handleOpenModal}><span><img src={upLine} alt="" className="small-svg" /> Send </span></li>
                                    <li onClick={handleOpenReceivedModal} ><span><img src={downLine} alt="" className="small-svg" /> Received</span></li>
                                </ul>
                            </div>
                        </Box> */}
            <div className="seperateBoxas ">
              <Grid2 className="ticketType" sx={{ marginBottom: "10px" }}>
                <Grid2
                  className={`ticketName ${
                    selectedTicket === "myTicket" ? "selected" : ""
                  }`}
                  onClick={() => handleTicketClick("myTicket")}
                >
                  My Ticket
                </Grid2>
                <Grid2
                  className={`ticketName ${
                    selectedTicket === "history" ? "selected" : ""
                  }`}
                  onClick={() => handleTicketClick("history")}
                >
                  History
                </Grid2>
              </Grid2>
              <div className="viewShow">
                {selectedTicket === "history" && (
                  <Box
                    variant="div"
                    sx={{ display: "flex", flexDirection: "column" }}
                  >
                    {historyData.map((item, index) => (
                      <Box
                        variant="div"
                        className="nftBox history"
                        key={index}
                        sx={{ display: "flex", alignItems: "center" }}
                      >
                        <div className="nftimage">
                          <img src={item.image} alt={item.title} />
                        </div>
                        <div className="nftdes">
                          <Typography className="nft-title">
                            {item.title}
                          </Typography>
                          <Typography className="nft-id">
                            {item.time}
                          </Typography>
                        </div>
                        <Typography
                          className={
                            item.type === "danger"
                              ? "textdanger"
                              : "textsuccess"
                          }
                          fontWeight={"500"}
                        >
                          {item.symbol}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                )}
                {selectedTicket === "myTicket" && (
                  <Link
                    component="div"
                    sx={{
                      textDecoration: "none !important",
                      color: "inherit !important",
                      cursor: "default !important",
                    }}
                    to={"/my-wallet/ticket-details"}
                  >
                    <Box variant="div" sx={{ display: "flex" }}>
                      {nftListData.map((item, index) => (
                        <Card
                          sx={{
                            margin: "5px",
                            borderRadius: "10px",
                            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                            height: "185px",
                            width: "50%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            variant="div"
                            className="position-relative "
                            sx={{ padding: "5px" }}
                          >
                            <CardMedia
                              className="radius-img-box"
                              component="img"
                              height="70"
                              image={item.image}
                              alt={item.title}
                            />
                            <CardContent
                              sx={{
                                padding: "9px 5px",
                                fontSize: "16px",
                                maxHeight: "56px",
                              }}
                            >
                              <Typography variant="div" className="nft-title">
                                {item.title}
                              </Typography>
                            </CardContent>
                          </Box>

                          {/* Footer with Link */}
                          <CardActions
                            sx={{
                              justifyContent: "center",
                              padding: "10px",
                              bgcolor: "#6638A2",
                            }}
                          >
                            <Typography
                              variant="div"
                              component="a"
                              href="/my-wallet/ticket-details"
                              sx={{
                                textDecoration: "none",
                                letterSpacing: "1px",
                                fontSize: "13px",
                                color: "#fff",
                                fontWeight: "500",
                                textTransform: "uppercase",
                              }}
                            >
                              Click here to re-sell
                            </Typography>
                          </CardActions>
                        </Card>
                      ))}
                    </Box>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </Box>
        <Footer />
      </div>

      <Modal
        open={openModal}
        onClose={handleCloseModal}
        className="modal-default"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" component="h2" mb={2}>
            Send to
          </Typography>
          <Grid2 className="close" onClick={handleCloseModal}>
            <img src={closeBtn} alt="" />
          </Grid2>
          <form className="loginForm">
            <div className="position-relative">
              <TextField
                variant="outlined"
                fullWidth
                type="text"
                margin="normal"
                placeholder="Send to"
              />
              <img src={qrimg} className="qr-modal" alt="" />
            </div>
            <div className="position-relative password-field">
              <TextField
                className="password-textbox"
                type="text"
                variant="outlined"
                fullWidth
                margin="normal"
                placeholder="HBAR Amount"
              />
              <Typography className="maxAmmount">Max</Typography>
            </div>
            <Typography className="current-balance">
              Current Balance : <b>65.039 HBAR</b>
            </Typography>
            <div className="position-relative password-field">
              <TextField
                className="password-textbox"
                type="text"
                variant="outlined"
                fullWidth
                margin="normal"
                placeholder="Memo"
                multiline
                rows={3}
              />
            </div>
            <Button
              onClick={handleOpenNextModal}
              className="btn-common center-btn-modal"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ marginTop: 2 }}
            >
              Next
            </Button>
          </form>
        </Box>
      </Modal>

      <Modal
        open={openNextModal}
        onClose={handleCloseNextModal}
        className="modal-default"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" component="h2" mb={4}>
            Confirm Transaction
          </Typography>
          <Grid2 className="close" onClick={handleCloseNextModal}>
            <img src={closeBtn} alt="" />
          </Grid2>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid className="event-info fullWidth">
                <Grid className="event-des fullWidth">
                  <Typography
                    sx={{
                      color: "#747688",
                      fontSize: "13px,",
                      fontWeight: "500",
                    }}
                  >
                    Confirm Send to
                  </Typography>
                  <Typography
                    sx={{ fontSize: "19px", fontWeight: 500, color: "#120D26" }}
                  >
                    0.0.5419567-vcpqi
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={6}>
              <Grid className="event-info fullWidth">
                <Grid className="event-des fullWidth">
                  <Typography
                    sx={{
                      color: "#747688",
                      fontSize: "13px,",
                      fontWeight: "500",
                    }}
                  >
                    Amount
                  </Typography>
                  <Typography
                    sx={{ fontSize: "19px", fontWeight: 500, color: "#120D26" }}
                  >
                    64.039 HBAR
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={6}>
              <Grid className="event-info fullWidth">
                <Grid className="event-des fullWidth">
                  <Typography
                    sx={{
                      color: "#747688",
                      fontSize: "13px,",
                      fontWeight: "500",
                    }}
                  >
                    Network Fees
                  </Typography>
                  <Typography
                    sx={{ fontSize: "19px", fontWeight: 500, color: "#120D26" }}
                  >
                    0.00031 HBAR
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid className="event-info fullWidth">
                <Grid className="event-des fullWidth">
                  <Typography
                    sx={{
                      color: "#747688",
                      fontSize: "13px,",
                      fontWeight: "500",
                    }}
                  >
                    Memo
                  </Typography>
                  <Typography
                    sx={{ fontSize: "19px", fontWeight: 500, color: "#120D26" }}
                  >
                    lorem ipsum dummy is memo text
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Typography className="current-balance modal-current-balance">
                Total : <b>65.039 HBAR</b>
              </Typography>
            </Grid>
            <Button
              onClick={handleCloseNextModal}
              className="btn-common center-btn-modal"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ marginTop: 2 }}
            >
              Send
            </Button>
          </Grid>
        </Box>
      </Modal>

      {/* Received Modal */}
      <Modal
        open={openReceivedModal}
        onClose={handleCloseReceivedModal}
        className="modal-default"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" component="h2" mb={2}>
            Received
          </Typography>
          <Grid2 className="close" onClick={handleCloseReceivedModal}>
            <img src={closeBtn} alt="" />
          </Grid2>
          <Grid2 container spacing={2}>
            <Grid2 item xs={12}>
              <Grid2>
                <img src={qrimg} alt="" className="receivedQR" />
              </Grid2>
            </Grid2>
            <Grid2 item xs={12} className="fullWidth" mb={0}>
              <Grid2 className="event-info fullWidth">
                <Grid2 className="event-des fullWidth">
                  <Typography
                    sx={{
                      color: "#747688",
                      fontSize: "13px,",
                      fontWeight: "500",
                      textAlign: "center",
                    }}
                  >
                    HBAR Deposit Address
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "19px",
                      fontWeight: 500,
                      color: "#120D26",
                      textAlign: "center",
                    }}
                  >
                    0.0.5419567-vcpqi
                  </Typography>
                </Grid2>
              </Grid2>
            </Grid2>
          </Grid2>
          <Button
            onClick={() => {
              handleCloseReceivedModal();
              handleOpenCopyModal();
            }}
            className="btn-common center-btn-modal large-Btn"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ marginTop: 2 }}
          >
            Copy Address to clipboard
          </Button>
        </Box>
      </Modal>

      {/* Copy Address Modal */}
      <Modal
        open={openCopyModal}
        onClose={handleCloseCopyModal}
        className="modal-default"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" component="h2" mb={2}>
            Copy Address
          </Typography>
          <Grid2 className="close" onClick={handleCloseCopyModal}>
            <img src={closeBtn} alt="" />
          </Grid2>
          <Grid2 className="copy-address">
            <Grid className="event-info fullWidth">
              <Grid className="event-des fullWidth">
                <Typography
                  sx={{
                    color: "#747688",
                    fontSize: "13px,",
                    fontWeight: "500",
                  }}
                >
                  No Checksum
                </Typography>
                <Typography
                  sx={{ fontSize: "19px", fontWeight: 500, color: "#120D26" }}
                >
                  0.0.5416445
                </Typography>
              </Grid>
              <img src={copyClipboard} alt="" className="copyClipboard" />
            </Grid>
            <Grid className="event-info fullWidth">
              <Grid className="event-des fullWidth">
                <Typography
                  sx={{
                    color: "#747688",
                    fontSize: "13px,",
                    fontWeight: "500",
                  }}
                >
                  With Checksum
                </Typography>
                <Typography
                  sx={{ fontSize: "19px", fontWeight: 500, color: "#120D26" }}
                >
                  0.0.5416445-scqjy
                </Typography>
              </Grid>
              <img src={copyClipboard} alt="" className="copyClipboard" />
            </Grid>
            <Grid className="event-info fullWidth">
              <Grid className="event-des fullWidth">
                <Typography
                  sx={{
                    color: "#747688",
                    fontSize: "13px,",
                    fontWeight: "500",
                  }}
                >
                  ETM Address
                </Typography>
                <Typography
                  sx={{ fontSize: "19px", fontWeight: 500, color: "#120D26" }}
                >
                  0x4e9d6df...e9650c0
                </Typography>
              </Grid>
              <img src={copyClipboard} alt="" className="copyClipboard" />
            </Grid>
          </Grid2>
          <Button
            onClick={handleCloseCopyModal}
            className="btn-common center-btn-modal large-Btn"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ marginTop: 2 }}
          >
            Done
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};

export default MyWallet;
